'use client';
import Image from 'next/image';
import NextLink from 'next/link';
import { twMerge } from 'tailwind-merge';

interface LogoProps {
    src: string;
    alt: string;
    width: number;
    height: number;
    href?: string;
    className?: string;
}

const Logo = ({
    src,
    alt,
    width,
    height,
    href = '/',
    className = ''
}: LogoProps) => {
    return (
        <NextLink
            href={href}
            className={twMerge(
                'inline-block transition-opacity duration-200 hover:opacity-80 focus:outline-none',
                className
            )}
            aria-label={`${alt} - Go to homepage`}
        >
            <Image
                src={src}
                alt={alt}
                width={width}
                height={height}
                priority
                className="h-auto object-contain"
            />
        </NextLink>
    )
}

export default Logo